// src/config.js
// Single place to build API URLs for both local (localhost/LAN) and Vercel/production.
// NOTE: No `import.meta` here so CRA/Babel won’t choke.

/**
 * Optional runtime globals you can inject in index.html if needed:
 * <script>
 *   window.__APP_ENV__ = { API_BASE: 'http://192.168.1.10:7001', IMAGES_BASE: '' };
 * </script>
 */
const RUNTIME = (typeof window !== 'undefined' && window.__APP_ENV__) || {};

// Prefer explicit environment overrides, then runtime globals, else empty.
const ENV_BASE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_API_BASE) ||
  RUNTIME.API_BASE ||
  '';

const IMAGES_BASE =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_IMAGES_BASE) ||
  RUNTIME.IMAGES_BASE ||
  '';

/**
 * If ENV_BASE is set, always use it (e.g. http://localhost:7001 or http://192.168.x.x:7001)
 * Otherwise:
 *  - on localhost dev, default to http://localhost:7001
 *  - on production (Vercel/site), return '' to use relative `/api/...`
 */
function resolveBase() {
  if (ENV_BASE) return ENV_BASE.replace(/\/+$/, '');

  const host =
    (typeof window !== 'undefined' && window.location.host) || '';
  const isLocal =
    host.startsWith('localhost') ||
    /^127\.0\.0\.1(?::\d+)?$/.test(host) ||
    /^192\.168\.\d{1,3}\.\d{1,3}(?::\d+)?$/.test(host);

  if (isLocal) return 'http://localhost:7001';
  return ''; // production → use relative /api
}

/** Build an API URL for backend routes (bmi-advice, horoscope, chat, picks…) */
export function apiUrl(path) {
  const base = resolveBase();
  const p = String(path || '');
  if (!base) return p; // production: /api/...
  return `${base}${p.startsWith('/') ? '' : '/'}${p}`;
}

/** Some endpoints you may want to force to a specific host (e.g., images CDN) */
export function imagesApiUrl(path) {
  const p = String(path || '');
  if (IMAGES_BASE) {
    const base = IMAGES_BASE.replace(/\/+$/, '');
    return `${base}${p.startsWith('/') ? '' : '/'}${p}`;
  }
  return apiUrl(p);
}